const initialState = {
  isCustomerView: false,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_OPTIONS':
      return {
        ...state,
        ...action.data,
      };
    case 'TOGGLE_CUSTOMER_VIEW':
      return {
        ...state,
        isCustomerView: action.data,
      };
    default:
      return state;
  }
};

export default profile;
